require('./bootstrap');
require('./helpers');

/* SECTIONS */
require('./sections/about');
require('./sections/map');
require('./sections/schedule');
require('./sections/speakers');
require('./sections/partners');

/* SHARED */
require('./shared/header');
require('./shared/googlePlayApp');
require('./shared/addUrlParams');
require('./shared/footer');
